import Button from '@atlaskit/button/standard-button';

import { useIntl } from 'src/hooks/intl';

import messages from './error-message-with-retry.i18n';
import * as styles from './error-message-with-retry.styled';

type ErrorMessageWithRetryProps = {
  errorMessage: string;
  onRetry?: () => void;
};

export const ErrorMessageWithRetry = (props: ErrorMessageWithRetryProps) => {
  const intl = useIntl();
  return (
    <>
      <styles.ErrorMessageContainer>
        {props.errorMessage}
      </styles.ErrorMessageContainer>

      {props.onRetry && (
        <styles.RetryButtonContainer>
          <Button appearance="link" onClick={props.onRetry}>
            {intl.formatMessage(messages.retryButtonLabel)}
          </Button>
        </styles.RetryButtonContainer>
      )}
    </>
  );
};
